/* eslint-disable import/no-cycle */
import {computed, decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {Preparation, PreparationState} from '../models/preparation';

export class PreparationStore extends EntityStore {
  preparations = [];

  constructor(rootStore) {
    super(rootStore, 'preparations', Api.preparations, Preparation);
  }

  filterUndoneByStorageUnitId(storageUnitId) {
    return this.preparations.filter(
      (preparation) => preparation.storageUnitId === storageUnitId && preparation.state !== PreparationState.DONE
    );
  }

  get currentPreparations() {
    const currentOperation = this.rootStore.operationStore.active;
    if (currentOperation) {
      return this.preparations.filter((preparation) => preparation.operationId === currentOperation.id);
    }
    return [];
  }

  get runningPreparations() {
    return this.currentPreparations
      .filter((preparation) => preparation.state !== PreparationState.DONE)
      .map((preparation) => {
        preparation.storageUnit = this.rootStore.storageUnitStore.getById(preparation.storageUnitId);
        return preparation;
      });
  }

  get donePreparations() {
    return this.currentPreparations.filter((preparation) => preparation.state === PreparationState.DONE);
  }
}

decorate(PreparationStore, {
  preparations: observable,
  currentPreparations: computed,
  runningPreparations: computed,
  donePreparations: computed,
});
